import { Address } from '@website/types/graphqlOperations';
import React, { Fragment } from 'react';
import countries from '../../../../dataObjects/countries';

type Props = {
  address: Address;
};

export default function GoogleMapsAutocompleteFieldAddressView({
  address,
}: Props) {
  const lines = [
    address.addressLine1,
    address.addressLine2,
    address.locality,
    address.dependentLocality,
    address.administrativeArea,
    address.postalCode,
    address.country ? countries[address.country] : '',
  ];
  return (
    <>
      {lines
        .filter((i) => i && i !== '')
        .map((i, key) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={key}>
            <span style={{ fontWeight: key === 0 ? 700 : 500 }}>{i}</span>
            <br />
          </Fragment>
        ))}
    </>
  );
}
